import { render, staticRenderFns } from "./feedbackTrip.vue?vue&type=template&id=545e3b6e&scoped=true"
import script from "./feedbackTrip.vue?vue&type=script&lang=js"
export * from "./feedbackTrip.vue?vue&type=script&lang=js"
import style0 from "./feedbackTrip.vue?vue&type=style&index=0&id=545e3b6e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "545e3b6e",
  null
  
)

export default component.exports